<template>
  <div class="common_content">
    <div class="message_detail">
      <el-card class="box-card">
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="24">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane label="全部" name="first">
                <div v-if="totalCount">
                  <div class="grid-content" v-for="(item,index) in data" :key="index">
                    <p class="sunP1">
                      <span style="position: relative;">{{item.message_title}}</span>
                      <span class="createDate">{{item.creationTime|dateformat('YYYY-MM-DD HH:mm')}}</span>
                    </p>
                    <p class="sunP2">{{item.message_content}}</p>
                  </div>
                </div>
                <no-data v-else />
                <div class="pagination" style="margin-top:20px;text-align: center">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :page-size="paging.limit"
                    v-if="totalCount>6"
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="未读" name="second">
                <div v-if="totalCount">
                  <div class="grid-content" v-for="(item,index) in data" :key="index">
                    <p class="sunP1">
                      <span style="position: relative;">{{item.message_title}}</span>
                      <span class="createDate">{{item.creationTime|dateformat('YYYY-MM-DD HH:mm')}}</span>
                    </p>
                    <p class="sunP2">{{item.message_content}}</p>
                  </div>
                </div>
                <no-data v-else />
                <div class="pagination" style="margin-top:20px;text-align: center">
                  <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange2"
                    :page-size="paging2.limit"
                    v-if="totalCount>6"
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetStationNewsList } from "@/api/admin/common.js";
import noData from "@/views/admin/components/noData.vue";
export default {
  components: {
    noData
  },
  data() {
    return {
      data: {},
      activeName: "first",
      paging: {
        limit: 6,
        page: 1,
        status: 0
      },
      paging2: {
        limit: 6,
        page: 1,
        status: 1
      },
      totalCount: 0
    };
  },
  created() {
    this.getAllList();
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name == "first") {
        // 全部信息
        this.getAllList();
      } else {
        // 未读信息
        this.getUnReadList();
      }
      
    },
    getAllList() {
      GetStationNewsList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    getUnReadList() {
      GetStationNewsList(Object.assign(this.paging2)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      GetStationNewsList(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    },
    handleCurrentChange2(cpage) {
      this.paging2.page = cpage;
      GetStationNewsList(Object.assign(this.paging2)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.message_detail {
  .grid-content {
    padding: 17px 0;
    border-bottom: 1px solid #f2f2f2;
    .sunP1 {
      color: #444;
      margin-bottom: 15px;
      .createDate {
        margin-left: 30px;
        color: #999;
        font-size: 12px;
      }
    }
    .sunP2 {
      font-size: 12px;
      color: #777;
    }
  }
}
</style>
